import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { forgotOtp } from "../../../redux/authslice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

function Forgetotp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [typedata, setTypedata] = useState("");

  useEffect(() => {
    const type = localStorage.getItem("type");
    if (type === "forgot") {
      setTypedata(type);
    } else {
      localStorage.setItem("type", "2FA");
      setTypedata("2FA");
    }
  }, []);

  const handleNextClick = () => {
    if (otp?.length < 6) {
      setError("OTP required.");
      return;
    } else {
      setError("");
      let body = {
        email: localStorage.getItem("email"),
        otp: otp,
        type: typedata,
      };
      dispatch(forgotOtp(body, navigate, dispatch));
      setOtp("");
    }
  };

  const handleChange = (otp) => {
    if (/^\d*$/.test(otp)) {
      setOtp(otp);
    }
    if (otp?.length < 0) {
      setError("Enter OTP.");
      return;
    } else {
      setError("");
    }
  };

  return (
    <div className="login-page-2 ">
      <p className="accout-p">
        Enter your One-Time <br /> Passcode{" "}
      </p>
      <p className="accout-p12">
        We have sent an OTP to your email address, enter the 6-digit code below
      </p>
      <div className="mar-15">
        <label className="label1" htmlFor="">
          Enter OTP{" "}
        </label>
        <div className="otp-div">
          <OtpInput
            value={otp}
            isInputNum={true}
            onChange={handleChange}
            numInputs={6}
            error={error}
            renderInput={(props) => (
              <input
                {...props}
                style={{
                  marginRight: "10px",
                  height: "40px",
                  width: "100%",
                  maxWidth: "10%",
                  borderRadius: "8px",
                  border: "none",
                  padding: "0px 15px",
                  color: "#000 !important",
                  overflow: "hidden",
                }}
              />
            )}
          />
        </div>
      </div>

      <p className="error_text">{error}</p>

      <div className="mar-15">
        <button className="login-bt" onClick={handleNextClick}>
          Next
        </button>
      </div>
    </div>
  );
}

export default Forgetotp;
